<template>
  <div class="flexbox" :class="type == 3?'small':''">
    <div class="num">{{ getNo }}</div>
    <div class="id">设备: cpr</div>
    <div class="data">
      <div class="left">
        <div class="color-box">
          <div class="point yellow" style="top:0%"></div>
          
        </div>
        <div class="press">
          0
        </div>
      </div>
      <div class="right">
        <div class="press">
          0
        </div>
        <div class="rate1">
          <div class="point_box">
            <div class="point"></div>
            <div class="shan1"></div>
            <div class="line-tick line-tick1">
              <div class="tick"></div>
              <div class="num">0</div>
            </div>
            <div class="line-tick line-tick1">
              <div class="tick"></div>
              <div class="num">0</div>
            </div>
            <div class="line-tick line-tick2">
              <div class="tick"></div>
              <div class="num">100</div>
            </div>
            <div class="line-tick line-tick4">
              <div class="tick"></div>
              <div class="num">120</div>
            </div>
            <div class="line-tick line-tick5">
              <div class="tick"></div>
              <div class="num"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlankBox',
  data() {
    return {
      // rate:50,
      
    }
  },
  props: ['num','total','type'],
  computed: {
    getNo(){
      if(this.type == 2){
        return 7 - this.total + this.num
      }else if(this.type == 3){
        return 21 - this.total + this.num
      }else{
        return 10 - this.total + this.num
      }
    }
  },
  methods:{
  },
  mounted(){
    // console.log('total',this.total)
    // console.log('num',this.num)
  }
}
</script>

<style scoped lang="less">
.flexbox.small{
  zoom: 0.6;
}
.flexbox{
  width: 5.6rem;
  max-width: 325px;
  height: calc(0.7*6rem);
  max-height: calc(0.7*325px);
  background: rgba(255, 255, 255, .4);
  margin-bottom: .8rem;
  position: relative;
  border-radius: .15rem;
  overflow: hidden;
  .num{
    color: #9ea3a3;
    font-size: .5rem;
    position: absolute;
    left: .125rem;
    top: .0625rem;
    z-index: 10;
    @media screen and (min-width: 1400px) {
      font-size: 24px;
    }
  }
  .id{
    color: #9ea3a3;
    position: absolute;
    bottom: .16rem;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: .2rem;
    @media screen and (min-width: 1400px) {
      font-size: 12px;
    }
  }
  .refresh{
    position:absolute;
    width: .7rem;
    right: .1rem;
    bottom: .16rem;
    max-width: 30px;
  }
  .status{
    width: 100%;
    height: 100%;
    position: relative;
    background: #575757;
    z-index: 9;
    img{
      width: 40%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .data{
    width: 4.6rem;
    max-width: 295px;
    height: calc(0.7*4rem);
    max-height: calc(0.6*255px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    display: flex;
    .left{
      width: 40%;
      height: 100%;
      justify-content: center;
      text-align: center;
      flex-direction: column;
      .reback:nth-child(1){
        .line{
          background: #f10f0f!important;
        }
      }
      .color-box{
        background: rgba(255, 255, 255,.5);
        width: 40%;
        height: 80%;
        margin: 0 auto;
        border-radius: .1rem;
        position: relative;
        .point{
          height: .1rem;
          width: 130%;
          position: absolute;
          top: 0;
          background: #f10f0f;
          left: -15%;
          border-radius: .1rem  ;
          z-index:2;
          transition: top;
        }
        .point.yellow{
          background: #fffc00;
        }
        .point.green{
          background: #7eff00;
        }
        .change-color{
          position: absolute;
          width: 100%;
          z-index: 1;
        }
        .change-color.yellow{
          top: 0;
          background: #f5e226;
          border-radius: .1rem .1rem 0 0;
        }
        .change-color.green{
          top: 50%;
          background: #62db00;
        }
      }
      .press{
        font-size: 0.45rem;
        text-align: center;
        margin: .1rem;
        color: #7a7b7b;
      }
      .line_box{
        width: 100%;
        height: 100%;
        flex: 1;
        display: flex;
        .line{
          display: block;
          width: 90%;
          height: .065rem;
          margin: auto;
          border-radius: 2px;
          background: #f5e226;
        }
        .line.yellow{
          background: #f5e226;
        }
        .line.green{
          background: #62db00;
        }
      }
    }
    .right{
      width: 60%;
      height: 100%;
      text-align: center;
      position: relative;
      .press{
        color: #7a7b7b;
        font-weight: 500;
        position: absolute;
        white-space: nowrap;
        font-size: .65rem;
        // top: .225rem;
        left: 50%;
        transform: translateX(-50%);
        @media screen and (min-width: 1400px) {
          // font-size: 18px;
        }
      }
      .rate{
        color: #fff;
        font-size: 1.4rem;
        position: absolute;
        bottom: .2rem;
        left: 50%;
        transform: translateX(-50%) ;
        @media screen and (min-width: 1400px) {
          font-size: 72px;
        }
      }
      .rate.yellow{
        color: #f5e226;
      }
      .rate.red{
        color: #f10f0f;
      }
      .rate1::after{
        content:"";
        position: absolute;
        width: 2.4rem;
        height: 2.4rem;
        top: 0;
        left: 0;
        border-radius: 100%;
        z-index: -1;
        background-image: var(--background-inner);
        transform: rotate(-90deg);
        transition: background-image 2s;
        @media screen and (min-width: 1400px) {
          width: 120px;
          height: 120px;
        }
      }
      .rate1{
        width: 100%;
        left: 50%;
        transform: translateX(-50%);
        height: 1.2rem;
        width: 2.4rem;
        border-radius: 2.4rem 2.4rem 0 0;
        position: absolute;
        bottom: .4rem;
        border: 3px solid #7a7b7b;
        border-bottom: none;
        @media screen and (min-width: 1400px) {
          height: 60px;
          width: 120px;
          border-radius: 120px 120px 0 0;
        }
        .point_box{
        width: 100%;
        height: 100%;
        position: relative;
          .point{
            width: 35%;
            height: 1px;
            background: #9ea3a3;
            position: absolute;
            bottom: 0px;
            right: 50%;
            // clip-path: polygon(0 1px, 40px 0, 40px 40px);
						transform-origin: right center;
            transition: transform 1s;
            transform: var(--pointer-rotate);
          }
          .line-tick{
            position: absolute;
            left: 0;
            bottom:0;
            width: 1.2rem;
            height: 2px;
						transform-origin: right center;
            @media screen and (min-width: 1400px) {
              width: 60px;
            }
            .tick{
              width: 10%;
              height: 100%;
              background: #9ea3a3;
            }
            .num{
              color: #7a7b7b;
              font-size: 0.2rem;
            }
          }
          .line-tick1 .num{position: absolute;left: -0.2rem;top:-5px; }
          .line-tick2{
            transform: rotate(45deg);
          }
          .line-tick2 .num{
            position: absolute;
            left: -0.3rem;
            top:-5px;
            transform: rotate(-90deg); 
          }
          .line-tick3{
            transform: rotate(90deg);
          }
          .line-tick3 .num{
            position: absolute;
            left: -0.3rem;
            top:-5px;
            transform: rotate(-90deg); 
          }
          .line-tick4{
            transform: rotate(135deg);
          }
          .line-tick4 .num{
            position: absolute;
            left: -0.3rem;
            top:-5px;
            transform: rotate(-90deg); 
          }
          .line-tick5{
            transform: rotate(180deg);
          }
          .line-tick5 .num{
            position: absolute;
            left: -0.4rem;
            top:-5px;
            transform: rotate(180deg); 
          }
        }
        // .point_box:hover .point{
        //   transform: rotate(180deg);
        // }
        
      }
    }
  }
}
</style>
